import { styled } from '@mui/material/styles';

export const DepartureWrapper = styled('div')(({ theme }) => ({
	display: 'flex',
	color: theme.palette.primary.main,
}));
